<template>
  <div>
    <v-chip small class="ma-2" color="primary">
      <span>{{ clientGames.length }} games</span>
    </v-chip>
    <v-chip v-if="session" small class="ma-2" color="primary">
      <span v-if="game.id == 'alfakodos'" >{{ daysLeft.daysLeftAK }} days left</span>
      <span v-if="game.id == 'jumblewords'">{{ daysLeft.daysLeftJ }} days left</span>
      <span v-if="game.id == 'targettimes'">{{ daysLeft.daysLeftTT }} days left</span>
    </v-chip>
    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
    <v-data-table :headers="headers" :items="clientGames" :items-per-page="10" :search="search" sort-by="name"
      :sort-desc="true" class="elevation-1">
      <template v-slot:item.game="{ item }">
        <action-game :item="item"></action-game>
      </template>
      <template v-slot:item.pdf="{ item }">
        <action-pdf v-if="game.id !== 'alfakodos'" :item="item"></action-pdf>
        <action-pdf-alfakodo v-else :item="item"></action-pdf-alfakodo>
      </template>
      <template v-slot:item.delete="{ item }">
        <action-crud :item="item" activity="delete"></action-crud>
      </template>
      <template v-slot:item.update="{ item }">
        <action-crud :item="item" activity="update"></action-crud>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import actionPdfAlfakodo from '@/components/actions/actPDFAlfakodo'
  import actionPdf from '@/components/actions/actPDF'
  import actionCrud from '@/components/actions/actCRUD'
  import actionGame from '@/components/actions/actGame'

  export default {
    components: {
      actionCrud,
      actionGame,
      actionPdf,
      actionPdfAlfakodo
    },
    created() {
      this.$store.dispatch('session/fetch')
      this.$store.dispatch(`${this.game.id}/fetch`)
    },
    props: [
      'game'
    ],
    computed: {
      ...mapState('session', ['session', 'daysLeft']),
      games() {
        return this.$store.state[this.game.id][this.game.id]
      },
      clientGames() {
        // If a client has been selected then filter by client ID
        if (this.session) {
          return this.games.filter(game => {
            return game.client_id == this.session.id
          })
        } else {
          return this.games
        }
      }
    },
    data() {
      return {
        search: "",
        headers: [{
            text: 'Name',
            value: 'name'
          },

          {
            text: 'Show Game',
            value: 'game'
          },
          {
            text: 'View PDF',
            value: 'pdf'
          },
          {
            text: 'Edit',
            value: 'update'
          },
          {
            text: 'Delete',
            value: 'delete'
          },
          {
            text: 'Created',
            value: 'created_at'
          },
          {
            text: 'Updated',
            value: 'updated_at'
          }
        ]
      }
    }
  }
</script>